// 客户类型
export const CUSTOMER_TYPES = {
  personal: {
    name: '个人',
    value: 1,
  },
  enterprise: {
    name: '企业',
    value: 2,
  },
}

// 租赁类别
export const RENT_CATEGORY = {
  rentCar: {
    name: '租车',
    value: 1,
  },
  rentPurchase: {
    name: '以租代购',
    value: 2,
  },
  driverCooperation: {
    name: '司机合作模式',
    value: 3,
  },
}

// 关联原因
export const RELATED_TYPE_LIST = [
  {
    name: '临时换车',
    value: 1,
  },
  {
    name: '订单换车',
    value: 2,
  },
  {
    name: '订单换人',
    value: 3,
  },
  {
    name: '订单续约',
    value: 4,
  },
  {
    name: '转租赁',
    value: 5,
  },
]

// 租金收款方式
export const PAYMENT_MODE_LIST = [
  {
    name: '年付',
    value: 1,
  },
  {
    name: '半年一付',
    value: 2,
  },
  {
    name: '周付',
    value: 3,
  },
  {
    name: '月付(满月)',
    value: 4,
  },
  {
    name: '月付(自然月)',
    value: 5,
  },
  {
    name: '一次性',
    value: 6,
  },
  {
    name: '三月一付',
    value: 8,
  },
  {
    name: '30天一付',
    value: 9,
  },
]
